module.exports = __webpack_public_path__ + "static/media/Teng.51d81262.jpg";